import { Component } from "react";
import { Helmet } from "react-helmet";

class Programs extends Component {
    state = {};
    render() {
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Programs</title>
                </Helmet>
            </div>
        );
    }
}

export default Programs;
